import { render, staticRenderFns } from "./WarningForm.vue?vue&type=template&id=370c219f"
import script from "./WarningForm.vue?vue&type=script&lang=js"
export * from "./WarningForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports